<template>
    <router-link
        :to="'/search?q=' + encodeURIComponent(text)"
        class="py-2 bg-white rounded-full text-sm px-4 text-center whitespace-nowrap"
    >
        {{ text }}
    </router-link>
</template>

<script>
export default {
    name: "AtomLabel",
    props: {
        text: {
            type: String,
            default: ""
        },
    },
}
</script>

<style scoped></style>
